import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "customer-edit-profile profile-with-tickets" }
const _hoisted_2 = { class: "project-tickets-section" }
const _hoisted_3 = { class: "project-tickets-list" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "empty-state",
  style: {"text-align":"center","margin-top":"20px"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "pro-t-l-content" }
const _hoisted_10 = {
  key: 0,
  class: "pagination-box"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "edit-profile-pages" }
const _hoisted_13 = { class: "edit-profile-in" }
const _hoisted_14 = { class: "edit-profile-in-l" }
const _hoisted_15 = { class: "user-pro-img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "active" }
const _hoisted_18 = { class: "edit-profile-in-r" }
const _hoisted_19 = { class: "profile-details" }
const _hoisted_20 = { class: "profile-details-row" }
const _hoisted_21 = { class: "profile-details-row" }
const _hoisted_22 = { class: "profile-details-row" }
const _hoisted_23 = { class: "profile-details-row" }
const _hoisted_24 = { class: "profile-details-row employee-project-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.constants.TICKETS_CREATED_BY_ME_TEXT), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.createdLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "loading-spinner" }, "Loading tickets...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.createdTickets.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No ticket is created "))
                : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdTickets, (issue) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: issue.id
                      }, [
                        _createVNode(_component_router_link, {
                          to: `/employee/issue-detail/${issue.key}`,
                          id: "ticketLink"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: issue.fields.issuetype?.iconUrl,
                                alt: ""
                              }, null, 8, _hoisted_8)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("strong", null, _toDisplayString(issue.key), 1),
                              _createElementVNode("p", null, _toDisplayString(issue.fields.summary), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
            ]))
      ]),
      (_ctx.createdTotalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("ul", null, [
              (_ctx.createdCurrentPage !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "pagination-first",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeCreatedPage(_ctx.createdCurrentPage - 1)))
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("button", { id: "paginationFirstButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdVisiblePages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  onClick: ($event: any) => (_ctx.changeCreatedPage(page))
                }, [
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass({ active: _ctx.createdCurrentPage === page })
                  }, _toDisplayString(page), 3)
                ], 8, _hoisted_11))
              }), 128)),
              (_ctx.createdCurrentPage !== _ctx.createdTotalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "pagination-last",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCreatedPage(_ctx.createdCurrentPage + 1)))
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("button", { id: "paginationLastButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.constants.PROFILE_TEXT), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: _ctx.displayImage,
              width: "100%",
              alt: "Profile Image"
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(_ctx.fullName) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.userProfileData.designation), 1)
          ]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("input", {
                type: "file",
                id: "fileUploadInput",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                accept: "image/*"
              }, null, 32),
              _createElementVNode("span", null, _toDisplayString(_ctx.constants.UPLOAD_PICTURE_LABEL), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                "data-bs-toggle": "modal",
                "data-bs-target": "#deleteProfileimg",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteProfileImage && _ctx.deleteProfileImage(...args)))
              }, _toDisplayString(_ctx.constants.DELETE_PICTURE_LINK), 1)
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: '/employee/profile',
                id: "viewProfileLink"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.constants.VIEW_PROFILE_LINK), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: '/employee/edit-profile',
                id: "editProfileLink"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.constants.EDIT_PROFILE_LINK), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.USERNAME_LABEL), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.userName), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.EMAIL_ADDRESS_LABEL), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.email), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.EDUCATION_LABEL), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.education), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.COMPANY_NAME_LABEL), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.comapanyName), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.COMPANY_WEBSITE_LABEL), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.websiteUrl), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.CONTACT_NO_LABEL), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.contactNumber), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.constants.ABOUT_ME_LABEL), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.userProfileData.aboutUs), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.PROJECT_LABEL), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userProfileData.projects, (project) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: project.id
                    }, _toDisplayString(project.name), 1))
                  }), 128))
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.constants.ROLE_LABEL), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userProfileData.projects, (project) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: project.id
                    }, _toDisplayString(project.role), 1))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear" }, null, -1))
      ])
    ])
  ]))
}